// libs
import { useSelector, useDispatch } from 'react-redux'
// store
import { showModal as showModalAction, hideModal as hideModalAction, updateModalData } from 'store/reducers/modals'
// types
import { Modals } from 'constants/modals'
import { RootState } from 'store/store'

export const useShowModal = ({ modalType }: { modalType: Modals }) => {
  const dispatch = useDispatch()

  const showModal = (modalData?: any) => dispatch(showModalAction({ modalType, modalData }))
  const hideModal = () => dispatch(hideModalAction(modalType))

  return {
    showModal,
    hideModal
  }
}

type ReturnType<T> = {
  modalData: { isOpen: boolean } & T
  hideModal: () => void
  updateModal: (modalData: any) => void
}

export const useModalData = <T extends Record<string, any>>({ modalType }: { modalType: Modals }): ReturnType<T> => {
  const dispatch = useDispatch()

  const modalData = useSelector((state: RootState) => state.modals[modalType] || { isOpen: false })

  const hideModal = () => dispatch(hideModalAction(modalType))
  const updateModal = (modalData: any) => dispatch(updateModalData({ modalType, modalData }))

  return { modalData, hideModal, updateModal }
}

export default useModalData
